import { render, staticRenderFns } from "./UploadHeader.vue?vue&type=template&id=1c01180a&scoped=true&"
import script from "./UploadHeader.vue?vue&type=script&lang=ts&"
export * from "./UploadHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UploadHeader.vue?vue&type=style&index=0&id=1c01180a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01180a",
  null
  
)

export default component.exports